module.exports = __webpack_public_path__ + "img/60-image-1-1@2x.deca384c.png";